import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Introduction from './components/Introduction/Introduction';
import KnowledgeHub from './components/KnowledgeHub/KnowledgeHub';
import Publications from './components/Publications/Publications';
import Resources from './components/Resources/Resources';
import ContactPage from './components/ContactPage/ContactPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminPage from './components/admin/AdminPage';
import AdminMessagesPage from './components/admin/AdminMessagesPage';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import SignIn from './components/admin/SignIn';
import CalWidget from "./components/CalWidget/CalWidget";

function App() {
  return (
    <Router>
      <div id="top" className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Introduction />
                <Publications />
                <KnowledgeHub />
                <Resources />
                <ContactPage />
              </>
            } />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/messages" element={
              <ProtectedRoute>
                <AdminMessagesPage />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
        <Footer />
        <CalWidget />
      </div>
    </Router>
  );
}

export default App;
